import React, { Component } from 'react';
import _ from 'lodash';
import { Nav, NavItem } from 'react-bootstrap';
import ProjectionStore from '../../../../stores/ProjectionStore';

let categoryTags = [];
let userTags = [];

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work should be undetaken to address this.
 */
class ProjectionEssentialSpends extends Component {
  constructor(props) {
    super(props);

    this.modifiedTags = this.modifiedTags.bind(this);
    this.modifiedUserTag = this.modifiedUserTag.bind(this);
    this.cbTags = this.cbTags.bind(this);
    this.userTags = this.userTags.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      key: 1,
      changeContentFlag: true,
      activeClass1: 'active',
      activeClass2: '',
    };
  }

  modifiedTags(id) {
    this.props.modifiedTags(id);
  }
  modifiedUserTag(id) {
    this.props.modifiedUserTag(id);
  }

  cbTags() {
    let divs;
    let activeTag = '';
    categoryTags = ProjectionStore.getCategoryTags();
    if (this.props.data !== undefined) {
      if (this.props.data.essentialSpends !== undefined) {
        const cTag = this.props.data.essentialSpends.map((cb) => {
          if (cb.categorytags.length > 0) {
            divs = cb.categorytags.map((cbtag) => {
              const value = _.indexOf(categoryTags, cbtag.id);
              activeTag = value < 0 ? 'tags' : 'tags selected';
              return (
                <p
                  className={activeTag}
                  onClick={this.modifiedTags.bind(this, cbtag.id)}
                  key={cbtag.id}
                  id={cbtag.id}
                >
                  <span className="icon icon-tag" />
                  &nbsp;&nbsp;{cbtag.tagName}
                </p>
              );
            });
            return <div className="tags-container">{divs}</div>;
          }
        });
        return cTag;
      }
    } else {
      return <div>Loading.............</div>;
    }
  }

  userTags() {
    let divs;
    let activeTag = '';
    userTags = ProjectionStore.getUserTags();
    if (this.props.data !== undefined) {
      if (this.props.data.essentialSpends !== undefined) {
        const tagcomp = this.props.data.essentialSpends.map((utags) => {
          if (utags.usertags.length > 0) {
            divs = utags.usertags.map((userTag, index) => {
              const value = _.indexOf(userTags, userTag.id);
              activeTag = value < 0 ? 'tags' : 'tags selected';
              return (
                <p
                  className={activeTag}
                  onClick={this.modifiedUserTag.bind(this, userTag.id)}
                  key={`ProjectionEssentialSpends_userTags_${userTag.id}`}
                  id={userTag.id}
                >
                  <span className="icon icon-tag" />
                  &nbsp;&nbsp;{userTag.tagName}
                </p>
              );
            });
          } else {
            return (divs = (
              <p key={`divs_empty`}>
                You have no 'Your tags' yet - you can create these when tagging
                in your account view
              </p>
            ));
          }
          return (
            <div className="tags-container" key={'tags-container_divs'}>
              {divs}
            </div>
          );
        });
        return tagcomp;
      }
    } else {
      return <div>Loading....................</div>;
    }
  }

  handleSelect(selectedKey) {
    if (selectedKey === 1) {
      this.setState({
        changeContentFlag: true,
        activeClass1: 'active',
        activeClass2: '',
      });
    } else {
      this.setState({
        changeContentFlag: false,
        activeClass1: '',
        activeClass2: 'active',
      });
    }
  }

  render() {
    return (
      <div className="projection-essentialSpends tags-mobile">
        <div className="essential-btns">
          <Nav
            justified
            activeKey={this.state.activeKey}
            onSelect={this.handleSelect}
            bsClass="nav nav-justified tag-nav"
          >
            <NavItem
              eventKey={1}
              value={1}
              href="#ourtags"
              className={this.state.activeClass1}
            >
              Our Tags
            </NavItem>
            <NavItem
              eventKey={2}
              value={2}
              href="#yourtags"
              className={this.state.activeClass2}
            >
              Your Tags
            </NavItem>
          </Nav>
        </div>
        <div className="essential-spend-tags">
          {this.state.changeContentFlag ? this.cbTags() : this.userTags()}
        </div>
      </div>
    );
  }
}

export { ProjectionEssentialSpends };
